import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAugmentedJQuery, IFormController, IModule, INgModelController, IPromise} from "angular";
import _ from "lodash";

require('./passordPrompt.scss');

/**
 * @deprecated - bruk reautentisering.ts
 */
export class PassordPromptDialogDialog {
    static regNavn = "passordPromptDialogDialog";

    static registrerDialog(angular: IModule) {
        angular
            .service(PassordPromptDialogDialog.regNavn, PassordPromptDialogDialog.forInjisering())
            .controller(PassordPromptDialogKontroller.regNavn, PassordPromptDialogKontroller.forInjisering())
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            PassordPromptDialogDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./passordPrompt.html'),
        controller: PassordPromptDialogKontroller.regNavn,
        controllerAs: '$ctrl',
        bindToController: true,
        multiple: true //tillater at vi viser denne dialogen uten av eventuelle eksisterende dialoger lukkes
    };

    visPassordPromptDialog(melding:string, validerPassord: (passord:string)=>IPromise<boolean>): IPromise<any> {
        return this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {
            locals: {
                melding: melding,
                validerPassord: validerPassord
            }
        }));
    }
}

export class PassordPromptDialogKontroller {
    static regNavn = "passordPromptDialogKontroller";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            regNavn.md.$mdConstant,
            regNavn.ng.$element,
            PassordPromptDialogKontroller
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService, private $mdConstant,  private $element:IAugmentedJQuery) {
        //for å unngå at nettleser fyller ut passord automatisk - som medfører at brukernavn blir fyllt inn i søkefeltet
        //(eller annet inputfelt som måtte være synlig i tillegg til passordfeltet) rendres passordfeltet først med type=text
        //for så etter 1sekund å bli endret til type=password
        setTimeout(()=>{
            $element.find('#vm-passordPromptDialog-passordfelt').attr('type', 'password');
        }, 1000);
    }

    validerPassord: (passord)=>IPromise<boolean>; //satt via locals.vedLukkDialog i dialogKonfigurasjon
    melding: string; //satt via locals.vedLukkDialog i dialogKonfigurasjon

    passord:string;

    validerPassordOgReturner(skjema:IFormController) {
        this.validerPassord(this.passord)
          .then(passordOk =>{
              skjema.passordFelt.$setValidity('ugyldigPassord', passordOk);
              if (!passordOk) return;
              this.lukkOgReturner();
          });
    }

    passordEndret(passordFelt:INgModelController) {
        if (passordFelt.$invalid) passordFelt.$setValidity('ugyldigPassord', true);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    //hjelpemetoder

    private lukkOgReturner() {
        this.$mdDialog.hide();
    }

}
